import { gql } from '@apollo/client';

export const PAY_NOW_OPTIONS_QUERY = gql`
  query PayNowOptions {
    payNowOptions {
      currency
      totalAmountInCents
      resources {
        ID
        contract {
          name
          id
          currentPaymentMethod {
            id
          }
        }
      }
    }
  }
`;
